import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-step',
  templateUrl: './tracking-step.component.html',
  styleUrls: ['./tracking-step.component.scss']
})
export class TrackingStepComponent implements OnInit  {
  constructor(){}
  ngOnInit(): void {
  }
}
